import { headerStyles } from "@insite/content-library/Widgets/InvoiceDetails/InvoiceDetailHeader";
import { css } from "styled-components";

headerStyles.printButton = {
    mergeCss: true,
    buttonType: "outline",
    variant: "secondary",
    css: css`
        margin-left: 10px;
    `,
}

headerStyles.narrowOverflowMenu = {
    cssOverrides: {
        wrapper: css`
            margin-left: 20px;
            button {
                min-width: 100%;
                &:hover {
                    border: none !important;
                    background: none !important;
                }
                &:focus {
                    outline: none !important;
                }
            }
        `,
    },
}